import { render, staticRenderFns } from "./SelectedRoundStatistics.vue?vue&type=template&id=d73734a2&scoped=true&"
import script from "./SelectedRoundStatistics.vue?vue&type=script&lang=js&"
export * from "./SelectedRoundStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SelectedRoundStatistics.vue?vue&type=style&index=0&id=d73734a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73734a2",
  null
  
)

export default component.exports